/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { fetchCloudRun } from "@/api/Helper";
import { IWhatsAppRequestTemplate } from "@/types/WhatsappTemplate";

export const createWhatsappTemplate = async (
  chatbotId: string,
  channelId: string,
  template: IWhatsAppRequestTemplate
): Promise<string> => {
  //process.env.VUE_APP_BASE_URL +
  const response = await fetchCloudRun(
    process.env.VUE_APP_BASE_URL +
      "/bot/chatbots/" +
      chatbotId +
      "/channels/whatsapp/" +
      channelId +
      "/templates",
    "POST",
    {},
    {
      name: template.name,
      category: template.category,
      translations: template.translations,
    }
  );
  return response;
};
